export function initVideoCustom($) {
    // Check if device is mobile (basic check)
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth < 768;

    $(".wp-block-video.is-style-custom").each(function (n, el) {
        let $video = $(el).find("video");
        let $container = $(el);
        let $btn = $(
            '<div class="playback-btn"><i class="icon-play fa-thin fa-volume fa-2x"></i><i class="icon-pause fa-thin fa-volume-xmark fa-2x"></i></div>'
        );
        $container.append($btn);

        let startMute = !!$video.prop("muted");
        let autoPlay = !!$video.prop("autoplay");
        let loopPlay = !!$video.prop("loop");
        let $modal = null;
        let $modalVideo = null;

        if (autoPlay && !startMute) {
            $video[0].muted = true;
        }

        // Create Bootstrap modal for desktop video playback
        if (!isMobile) {
            $modal = $(`
                <div class="modal fade video-playback-modal" tabindex="-1" role="dialog">
                    <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
                        <div class="modal-content bg-transparent border-0">
                            <button type="button" class="close text-white video-close-btn" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                            <div class="modal-body p-0">
                                <div class="video-modal-video"></div>
                            </div>
                        </div>
                    </div>
                </div>
            `);
            $('body').append($modal);
        }

        // make $btn follow mouse
        $container.on("mousemove", function (e) {
            $btn.css({
                left: e.pageX - $container.offset().left,
                top: e.pageY - $container.offset().top,
            });
        });

        // when mouse leaves the bounds of $container, hide the $btn
        $container.on("mouseleave", function (e) {
            $btn.addClass("hidden");
        });

        $container.on("mouseenter", function (e) {
            $btn.removeClass("hidden");
        });

        $container.on("click", function (e) {
            let vid = $video[0];
            let playing = $container.hasClass("playing");

            if (playing) {
                $container.removeClass("playing");

                if (autoPlay) {
                    vid.muted = true;
                } else {
                    vid.pause();
                }

                // if not autoplay then return to initial state
                if (!autoPlay) {
                    vid.src = vid.src;
                }

                // Close Bootstrap modal on desktop
                if (!isMobile && $modal) {
                    $modal.modal('hide');
                }
            } else {
                $container.addClass("playing");
                vid.muted = false;
                vid.play();

                // Show Bootstrap modal on desktop
                if (!isMobile && $modal) {
                    // Move video to modal
                    $modalVideo = $video.detach();
                    $modal.find('.video-modal-video').append($modalVideo);
                    $modal.modal('show');
                    // Ensure video plays in modal
                    vid.play();
                }
            }
        });

        // when video ends, show the poster
        $video.on("ended", function (e) {
            if (!loopPlay && !autoPlay) {
                $container.removeClass("playing");
                $video[0].src = $video[0].src;

                // Close Bootstrap modal on desktop
                if (!isMobile && $modal) {
                    $modal.modal('hide');
                }
            }
        });

        // Handle Bootstrap modal close event
        if (!isMobile && $modal) {
            // Handle close button click
            $modal.find('.video-close-btn').on('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                $modal.modal('hide');
            });

            // Handle modal hidden event
            $modal.on('hidden.bs.modal', function() {
                // Stop video and move it back to original container
                if ($container.hasClass("playing")) {
                    $container.removeClass("playing");
                    let vid = $video[0];
                    if (autoPlay) {
                        vid.muted = true;
                    } else {
                        vid.pause();
                        vid.src = vid.src;
                    }
                }
                if ($modalVideo) {
                    $container.prepend($modalVideo);
                    $modalVideo = null;
                }
            });
        }
    });
}
